import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { modalTypes } from '../../../../enums/modalTypeEnum'
import { typeYfDisplay } from '../../../../enums/yfManagerEnums'
import YFDisplay from '../../../yf_popin/YFDisplay'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            subHeaderStyle: {
                width: '80%',
                maxWidth: 1100,
                margin: '54px auto 0',
                '& p': {
                    color: theme.palette.blue.main,
                    margin: 0
                }
            },
            imgStyle: {
                height: 86,
                width: 86,
                '& svg': {
                    fill: theme.palette.blue.main,
                    width: 66,
                    height: 66
                },
                '& img': {
                    width: 86,
                    height: 86
                }
            }
        }
    )
)

interface AcceptingProps {
    fromType: modalTypes,
    title: string | undefined
}

type SubHeaderProps = AcceptingProps

const SubHeader: React.FC<SubHeaderProps> = (
    {
        fromType,
        title
    }
) => {
    const classes = useStyle()

    const subHeaderClass: ClassValue = classNames(
        'row middle-xs',
        classes.subHeaderStyle
    )

    const imageClass: ClassValue = classNames(
        'col-xs-1',
        classes.imgStyle
    )

    return (
        <div className={subHeaderClass}>
            <div className={imageClass}>
                <YFDisplay type={typeYfDisplay.REQUEST} />
            </div>

            <div className="col-xs-11">
                <p className={classes.title4}>
                    {
                        fromType === modalTypes.demandes && (
                            <FormattedMessage
                                id="requests.makeRequest.title"
                                defaultMessage="Déposer une demande"
                                description="Make request title"
                            />
                        )
                    }
                    {
                        fromType === modalTypes.response && (
                            <FormattedMessage
                                id="requests.response.title"
                                defaultMessage="Déposer une réponse"
                                description="Make request title"
                            />
                        )
                    }
                    {
                        fromType === modalTypes.service && (
                            <FormattedMessage
                                id="services.modal.form.title"
                                defaultMessage="Le service '{title}' vous intéresse"
                                description="Modal service title"
                                values={
                                    {
                                        title: title
                                    }
                                }
                            />
                        )
                    }
                </p>
                {
                    fromType === modalTypes.response && (
                        <p className={classes.title1}>
                            {title}
                        </p>
                    )
                }
                {
                    fromType === modalTypes.demandes && (
                        <p className={classes.title1}>
                            <FormattedMessage
                                id="requests.makeRequest.more"
                                defaultMessage="Pourriez-vous m'en dire davantage ?"
                                description="Make request text"
                            />
                        </p>
                    )
                }
                {
                    fromType === modalTypes.service && (
                        <p className={classes.title1}>
                            <FormattedMessage
                                id="services.modal.form.subtitle"
                                defaultMessage="Avez-vous des questions spécifiques ?"
                                description="Modal subtitle"
                            />
                        </p>
                    )
                }
            </div>
        </div>
    )
}

export default SubHeader
